import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import NumberComponent from '../../components/NumberComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DatePickerComponent from '../../components/DatePickerComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import { CubeJSContext } from '../../context/CubeJSProvider';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { format } from 'date-fns'

const applyFilter = (query, storeFilter) => {
  let storeCodeFilterObj = {
    member: "Carts.storeCode",
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }
  return query
}

const OutstandingTableNetSalesQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  var result = {}
  let query1 = {
    ...OmnitechQueries.carts.OutstandingTableNetSales.query,
    "timeDimensions": [
      {
        "dimension": "Carts.createdAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ]
  }
  query1 = applyFilter(query1, storeFilter)
  if(isRefresh)
    query1 = {}
  result["netSales"] = useCubeQuery(query1, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return result
}

const OutstandingTableDetailQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.outstandingTablePage.detail.name'),
    tableHeaders: {
      "CartTransactions.sumLineTotal": { name: t('page.fnb.outstandingTablePage.detail.tableHeader.sumLineTotal'), type: 'number'},
      "Carts.storeCode": { name: t('page.fnb.outstandingTablePage.detail.tableHeader.storeCode'), type: 'string'},
      "Carts.dineInTableNumber": { name: t('page.fnb.outstandingTablePage.detail.tableHeader.dineInTableNumber'), type: 'number'},
      "Carts.dineInTableSubNumber": { name: t('page.fnb.outstandingTablePage.detail.tableHeader.dineInTableSubNumber'), type: 'string'},
      "InternalAppOperators.staffNumber": { name: t('page.fnb.outstandingTablePage.detail.tableHeader.staffNumber'), type: 'string'},
      "InternalAppOperators.firstName": { name: t('page.fnb.outstandingTablePage.detail.tableHeader.firstName'), type: 'string'},
      "InternalAppOperators.lastName": { name: t('page.fnb.outstandingTablePage.detail.tableHeader.lastName'), type: 'string'}
    },
    grid: {xs: 12, md: 9, lg: 10},
    export: { allowExport: true, filename: 'outstanding_table_details_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.carts.OutstandingTableDetail.query,
    "timeDimensions": [
      {
        "dimension": "Carts.createdAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ]
  }
  query = applyFilter(query, storeFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const OutstandingTablePage = () => {
  const { t } = useTranslation();
  const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);
  const [ refresh2, setRefresh2 ] = useState(false);

  const { item, result }  = OutstandingTableDetailQuery(storeFilter, startDateFilter, endDateFilter, refresh1, setRefresh1)
  const resultSets = OutstandingTableNetSalesQuery(storeFilter, startDateFilter, endDateFilter, refresh2, setRefresh2)
  const itemDashboard = {grid: {xs: 12, md: 3, lg: 2, height: '10vw'}}

  const refresh = () => {
    setRefresh1(true)
    setRefresh2(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.outstandingTable')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage]}
          stateChanger={setStoreFilter} textLabel={t('page.fnb.outstandingTablePage.filter.store.name')} selectArray={storeCodeSelect}/>
      <DatePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter}  pageChangerArr={[setPage]} dateLabel={t('page.fnb.outstandingTablePage.filter.cartCreatedAt.date')}/>
    </Dashboard>,
    <Dashboard direction="row-reverse">
      <NumberComponent item={itemDashboard} query={resultSets["netSales"]}
        titleName={t('page.fnb.outstandingTablePage.netSales.name')}
        fieldName="CartTransactions.sumLineTotal" />
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default OutstandingTablePage;